module.exports = {"id":"188350","name":"Marco Reus","rating":"85","photo":"./data/images/photos/2/188350.png","club":{"name":"Bor. Dortmund","logo":"./data/images/clubs/Bor.Dortmund.png"},"positions":["MG","BU","AG","MOC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcoReus0.json
// module id = 2745
// module chunks = 0